module.exports = __webpack_public_path__ + "img/96.da8dab08.jpg";